import { getWeekFromPeriodId } from '#models/general/periods';
import { getDateFromDateAndTime } from '#models/general/dates/index';
import { takeNCharacters } from '#utils/string';

// Function that generates Ids for Adelphi steps (Mash, Wash and Spirit)
// These ids are the identifiers for each of the records steps
// We have 3 types of ids: MashId, WashId (first and second still) and SpiritId (first and second still)
// An id is composed has the next format: (mainLetter) => `${mainLetter}${washNumber} - ${mainLetter}S${washNumber} - ${week}`
// The generateMainId has to be developed for each substep that needs it
export const generateId =
  (generateMainId, target, needsFullPeriodId = false) =>
  (values, number, secondNumber = number) => {
    const week = getWeekFromPeriodId(values?.periodId);
    const mainId = generateMainId(number, needsFullPeriodId ? values?.periodId : week, secondNumber);
    return values?.[target] ? `${mainId} - ${getDateFromDateAndTime(values?.[target])}` : mainId;
  };

export const getCurrentNumberId = mashingId => {
  const first3Chars = takeNCharacters(3)(mashingId);
  return first3Chars.slice(-2);
};
